import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import ConfigApi from "@/api/Config";

import { ConfigServerResponse } from "@/types/global.d";
import OrganizationModel from "@/model/Organization";

@Module({ namespaced: true })
export default class AppModule extends VuexModule {
  axiosLoading = 0;
  pageTitle = "";
  pageDescription = "";

  public reportYear: number = new Date().getFullYear();
  public organizations: any = {};

  @Mutation setLoading() {
    this.axiosLoading += 1;
  }

  @Mutation clearLoading() {
    this.axiosLoading -= 1;
  }

  @Mutation setPageTitle(title: string) {
    this.pageTitle = title;
  }

  @Mutation setPageDescription(description: string) {
    this.pageDescription = description;
  }

  @Mutation
  setReportYear(value: number) {
    this.reportYear = value;
  }

  @Mutation
  setOrganizations(value: OrganizationModel[]) {
    this.organizations = value;
  }

  get isLoading() {
    return !!this.axiosLoading;
  }

  @Action getConfig() {
    return ConfigApi.getConfig().then((res: ConfigServerResponse) => {
      this.context.commit("setReportYear", res.object.reportYear);
      this.context.commit("setOrganizations", res.object.organizations);

      return res;
    });
  }
}
